import { ErrorCode } from '@planning/utils/ErrorCode/error-code-enum'
import {
  getDomainModelExceptionPayload,
  isDomainModelException,
} from '@planning/utils/ErrorCode/error-code-utils'
import { useTranslate } from '@tolgee/react'

export const useDangerousGoodsDefinitionMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = (isToAdd: boolean) => {
    return isToAdd
      ? t('unNumberCreationSuccess', 'The Un number is successfully created')
      : t('unNumberUpdateSuccess', 'The Un number is successfully updated')
  }

  const getExceptionMessage = (error: any) => {
    if (isDomainModelException(error, ErrorCode.EntityNotFound)) {
      const payload = getDomainModelExceptionPayload(error, ErrorCode.EntityNotFound)
      return t('entityNotFound', '{entity} with Id {id} not found', {
        entity: payload?.name ? t(payload?.name, payload?.name) : t('unNumber', 'Un number'),
        id: payload?.id,
      })
    }

    if (isDomainModelException(error, ErrorCode.NameNotUnique)) {
      const payload = getDomainModelExceptionPayload(error, ErrorCode.NameNotUnique)
      return t('nameNotUniqueWithField', 'Field {field} with value {value} is not unique', {
        field: t(payload.property ?? 'unNumber', 'Un number'),
        value: payload.value,
      })
    }

    if (isDomainModelException(error, ErrorCode.InvalidLength)) {
      const payload = getDomainModelExceptionPayload(error, ErrorCode.InvalidLength)
      return t(
        'invalidLengthWithField',
        'Field {field} has an invalid length, required length is {length}',
        {
          field: t(payload.property ?? 'unNumber', 'Un number'),
          length: payload?.requiredLength,
        },
      )
    }

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
